import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { ServiceError, useError } from 'Src/network/useError';

import provisionService, { OrganizationOption } from './provisionService';

const queryKeys = {
  getAll: () => ['PROVISIONER:GET:Organizations'],
};

const useQuery_GetAllOrganizationOptions = () => {
  const { t } = useTranslation();
  const { parseError } = useError({ activity: t('organization.errors.getAll') });
  return useQuery<OrganizationOption[], ServiceError>({
    queryKey: queryKeys.getAll(),
    queryFn: async () => {
      try {
        return await provisionService.organization.getAll({});
      } catch (e) {
        throw parseError(e);
      }
    },
  });
};

const useOrganization = {
  query: {
    getAll: useQuery_GetAllOrganizationOptions,
  }
};

export { useOrganization };

